import { ButtonHTMLAttributes, ReactNode } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'ghost';
  icon?: ReactNode;
  children: ReactNode;
}

export function Cta({ variant = 'primary', icon, children, className = '', ...rest }: Props) {
  const base =
    'inline-flex items-center justify-center gap-2 w-full min-h-[48px] px-4 py-3 rounded-full font-bold text-sm transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline-2 focus-visible:outline-offset-2';
  const styles =
    variant === 'primary'
      ? 'text-[#0A1128] focus-visible:outline-cyan-400'
      : 'bg-transparent text-[#0F1E33] border border-[var(--line-strong,rgba(15,30,51,0.16))] hover:bg-[var(--canvas,#F5F7FA)]';
  const primaryStyle =
    variant === 'primary'
      ? {
          background:
            'linear-gradient(135deg, var(--brand-primary,#22D3EE), var(--brand-blue-accent,#2D7FF9))',
          boxShadow: 'var(--shadow-cta)',
        }
      : undefined;

  return (
    <button
      type="button"
      className={`${base} ${styles} ${className}`}
      style={primaryStyle}
      {...rest}
    >
      {icon}
      <span>{children}</span>
    </button>
  );
}
